export default __webpack_public_path__ + "static/media/logo.811284d6.png";